import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = 240;

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    width: '100%',
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    marginTop: theme.spacing(8),
    flexGrow: 1,
    width: '100vw',
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(2) + 1,
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
    background: theme.palette.secondary.dark,
  },

  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
    background: theme.palette.secondary.dark,
  },
  headerRoot: {
    flexGrow: 1,
    backgroundColor: '#C6C6C6',
  },
  headerLabel: {
    textAlign: 'right',
    color: theme.palette.common.black,
  },
  headerLabelLeft: {
    textAlign: 'left',
    color: theme.palette.common.black,
  },
  labelBottom: {
    marginBottom: theme.spacing(1),
  },
  header: {
    backgroundColor: theme.palette.secondary.main,
  },

  icons: {
    color: theme.palette.primary.main,
    '&$:selected': {
      backgroundColor: 'red',
      color: 'red',
    },
  },
  divider: {
    backgroundColor: theme.palette.primary.main,
    height: '3px',
  },
  chip: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
    marginTop: 12,
    fontWeight: 'bold',
  },
  chipLabel: {
    color: 'white',
  },
  sideNavLink: {
    textDecoration: 'none',
    color: theme.palette.primary.main,
  },
  sideNavText: {
    color: theme.palette.common.white,
  },
  closeIcon: {
    color: theme.palette.primary.main,
  },
  button: {
    margin: theme.spacing(1),
    color: 'white',
    minWidth: '100px',
    background: theme.palette.secondary.dark,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  link: {
    textDecoration: 'none',
  },
  logoutButton: {
    fontWeight: 900,
    marginLeft: 25,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.dark,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
    },
  },
  subHeader: {
    color: 'white',
  },
  
    nested: {
      paddingLeft: theme.spacing(4)
    },
    nestedSecondLevel: {
      paddingLeft: theme.spacing(8)
    }
}));
